export enum Languages {
  En = 'en',
}

export interface LangItems {
  [langName: string]: string;
}

export interface LangConfig {
  default: Languages;
  items: LangItems;
}

const langConfig: LangConfig = {
  default: Languages.En,
  items: {
    [Languages.En]: 'English',
  },
};

export default langConfig;
